module.exports = __webpack_public_path__ + "images/goal-miner-b0d438ec0c7d4c23c5de69242b0267a0.png";